import React, { useContext } from 'react';
import { AuthContext } from './index';

export default function (mapFn) {
  return function (ReactComponent) {
    return function AuthConnectFunction (componentProps) {
      return (
        <AuthContext.Consumer>
          {({ store }) => {
            if (!store) {
              console.warn('authconnect: store is undefined');
              return <ReactComponent {...componentProps} />;
            }

            const { dispatch, getState } = store;
            if (!getState) {
              console.warn('authconnect: getState is undefined');
              return <ReactComponent {...componentProps} />;
            }

            const authState = getState();
            const props =
              mapFn && store ? mapFn(authState, componentProps) : {};

            return (
              <ReactComponent
                {...componentProps}
                {...props}
                authdispatch={dispatch}
              />
            );
          }}
        </AuthContext.Consumer>
      );
    };
  };
}

export const useAuth = () => {
  const { store } = useContext(AuthContext);
  if (!store || !store.getState) {
    console.warn('useAuth: store or getState is undefined');
    return {};
  }
  return store.getState();
};

export const useAuthSession = () => {
  const auth = useAuth();
  return auth?.session;
};

/**
 * @returns {boolean} Whether the current user is a loan officer
 */
export const useIsLoanOfficer = () => {
  const session = useAuthSession();
  return session?.isLoanOfficer ?? false;
};

export const useIsAuthenticated = () => {
  const auth = useAuth();
  if (typeof auth?.isAuthenticated === 'function') {
    return auth.isAuthenticated();
  }
  return false;
};
